import { render, staticRenderFns } from "./NotificationTeacher.vue?vue&type=template&id=2d5a83d0&scoped=true"
import script from "./NotificationTeacher.vue?vue&type=script&lang=js"
export * from "./NotificationTeacher.vue?vue&type=script&lang=js"
import style0 from "./NotificationTeacher.vue?vue&type=style&index=0&id=2d5a83d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5a83d0",
  null
  
)

export default component.exports